<template>
  <div class="layout-center-wrap">
    <article class="mail_card">
      <h2 class="mail_card__title">Email Authentication</h2>
      <p class="mail_card__text">
        The Vulnerability Reporting Page requires that uou verify your email
        address.
      </p>
      <p class="mail_card__text">
        We sent an email to your inbox. <br />
        Please verify your email address so we know that it's really you!
      </p>
      <div class="mail_card__form">
        <div class="mail_card__email-form">
          <label for="email" class="sr-only">your email address</label>
          <input
            type="email"
            id="email"
            class="input"
            v-model="authInfo.email"
            v-if="!isAuthEmail"
            placeholder="Please enter your email address"
          />
          <input
            type="text"
            id="code"
            class="input"
            v-model="authInfo.authCode"
            v-if="isAuthEmail && !isAuthCode"
            placeholder="Please enter the verification code."
          />
          <span class="time" v-if="isAuthEmail && !isAuthCode">{{
            formattedTime
          }}</span>
        </div>
        <div class="btn__wrap type-m-column">
          <!-- 이메일 전송 전 -->
          <button
            v-if="!isAuthEmail"
            class="btn btn--l btn--blue"
            @click="authEmail"
          >
            Send
          </button>

          <!-- 이메일 전송 후, 인증 코드 미입력 -->
          <button
            v-if="isAuthEmail && !isAuthCode"
            class="btn btn--l btn--green"
            @click="verifyAuthCode"
          >
            Verify
          </button>

          <button
            v-if="isAuthEmail && !isAuthCode"
            class="btn btn--l btn--medium_gray btn--auto"
            @click="authEmail"
          >
            Resend verification email
          </button>
        </div>
      </div>
    </article>
  </div>
</template>


<script>
import { useRouter, useRoute } from "vue-router";
import { inject, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import Auth from "./Auth.vue";
import dc from "@/component/DataChk.js";
import gt from "@/component/GetTokenValue.js";
import { generateRandomString } from "@/component/Crypto.js";

export default {
  components: {
    Auth,
  },
  setup() {
    const axios = inject("axios");
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의

    const defaultAuthInfo = () => ({
      id: generateRandomString(),
      email: "",
      authCode: "",
    });

    const authInfo = ref(defaultAuthInfo());

    const isAuthEmail = ref(false);
    const isAuthCode = ref(false);
    const authTime = ref(300);
    let authTimeInterval = null;

    // methods 정의
    const applySelection = () => {};

    const validateEmail = (email) => {
      if (!dc.nullChk(email)) {
        alert("Please enter your email address");
        return false;
      } else if (!dc.emailValidChk(email)) {
        alert("Please verify your email.\nex) korea@kisa.co.kr");
        return false;
      }

      return true;
    };

    const authEmail = () => {
      isAuthEmail.value = false;
      if (!validateEmail(authInfo.value.email)) {
        return false;
      }
      showLoading();
      axios
        .post("/core/pu/mail/verify/send", {
          userId: authInfo.value.id,
          userEmail: authInfo.value.email,
          recipientType: "FOREIGNER",
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            isAuthEmail.value = true;

            alert(
              "A verification email has been sent. Please check your inbox and enter the verification code."
            );
            startTimer();
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const verifyAuthCode = () => {
      isAuthCode.value = false;
      if (!dc.nullChk(authInfo.value.authCode)) {
        alert("Please enter the authentication number");
        return false;
      }

      showLoading();
      axios
        .post("/core/pu/mail/verify", {
          userId: authInfo.value.id,
          userEmail: authInfo.value.email,
          authCode: authInfo.value.authCode,
          recipientType: "FOREIGNER",
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            isAuthCode.value = true;
            clearInterval(authTimeInterval);

            nonMemberlogin();
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const nonMemberlogin = () => {
      showLoading();
      axios
        .post("/core/pu/member/non/login", {
          id: authInfo.value.id,
          guestType: "foreigner",
        })
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            router.push({ name: "reportForeignUser" });
          } else {
            axios.setErrorSession(1003, res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };

    const startTimer = () => {
      // 기존 타이머 정리
      clearInterval(authTimeInterval);
      authTime.value = 300; // 초기화 (5분)

      authTimeInterval = setInterval(() => {
        authTime.value--;

        if (authTime.value <= 0) {
          clearInterval(authTimeInterval);
          alert(
            "The authentication time has expired.\nPlease request re-authentication"
          );
        }
      }, 1000);
    };

    // computed정의

    // 시간 표시용 계산 속성
    const formattedTime = computed(() => {
      const min = Math.floor(authTime.value / 60)
        .toString()
        .padStart(2, "0");
      const sec = (authTime.value % 60).toString().padStart(2, "0");
      return `${min}:${sec}`;
    });

    // life cycle 정의
    onMounted(() => {
      const role = gt.getRole();
      if (role === "NONMEMBER") {
        router.push({ name: "reportForeignUser" });
      }
    });

    // html에서 사용될 데이터 정의
    return {
      authEmail,
      isAuthEmail,
      isAuthCode,
      authTime,
      formattedTime,
      verifyAuthCode,
      applySelection,
      authInfo,
    };
  },
};
</script>